import React from "react";
import "./SectionTitle.css";

export const SectionTitle = (props) => {
  return (
    <div className="sectionTitle">
      <h2>{props.title ? props.title : "No title in props"}</h2>
    </div>
  );
};
